import React from 'react';

import dayjs, { preferredTimeZone } from '@/components/NewUI/utils/dayjs';

const parseWallDate = (date: string) => {
  const parsed = dayjs.tz(date, preferredTimeZone);
  const previousOffset = dayjs(parsed.valueOf() - 24 * 60 * 60 * 1000)
    .tz(preferredTimeZone)
    .utcOffset();
  const difference = previousOffset - parsed.utcOffset();
  if (difference > 0) {
    const earlier = parsed.subtract(difference, 'minute').tz(preferredTimeZone);
    if (earlier.format('YYYY-MM-DD HH:mm:ss.SSS') === parsed.format('YYYY-MM-DD HH:mm:ss.SSS'))
      return earlier;
  }
  return parsed;
};

const FormattedDate = ({ date }: { date: string }) => {
  const parsed = dayjs(date);
  const datePart = /^\d{4}-\d{2}-\d{2}/.exec(date)?.[0];
  const validCalendarDate = !datePart || dayjs(datePart, 'YYYY-MM-DD', true).isValid();
  const formatted =
    parsed.isValid() && validCalendarDate
      ? (/([zZ]|[+-]\d{2}:?\d{2})$/.test(date)
          ? parsed.tz(preferredTimeZone)
          : parseWallDate(date)
        ).format('DD MMM YYYY,-h:mma z')
      : 'Invalid date';
  return (
    <>
      {formatted.split('-').map((line) => (
        <span key={line}>{line}</span>
      ))}
    </>
  );
};

export default FormattedDate;
